import { render, staticRenderFns } from "./RoleList.vue?vue&type=template&id=b111b764&scoped=true&"
import script from "./RoleList.vue?vue&type=script&lang=js&"
export * from "./RoleList.vue?vue&type=script&lang=js&"
import style0 from "./RoleList.vue?vue&type=style&index=0&id=b111b764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b111b764",
  null
  
)

export default component.exports